import { compose, lifecycle, withState, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import LocateDuplicatesButton from './components/LocateDuplicatesButton';
import { getUserUrlPrefix, getIsCommissionBarber } from '../../../../auth/selectors';
import { locateDuplicates } from '../actions';
import withActiveUserIdAndType from '../../../../common/hoc/withActiveUserIdAndType';

export default compose(
  withActiveUserIdAndType({ useShopForBarber: true }),
  withState('isVisible', 'setVisible', false),
  connect((state, ownProps) => {
    const urlPrefix = getUserUrlPrefix(state);
    const customerId = ownProps.customerId ? `/${ownProps.customerId}` : '';
    return {
      link: `${urlPrefix}/customers/duplicates${customerId}`,
      isCommissionBarber: getIsCommissionBarber(state),
    };
  }),
  branch(props => props.isCommissionBarber, renderNothing),
  lifecycle({
    componentDidMount() {
      const { customerId, activeId, activeType } = this.props;
      if (!customerId) {
        return this.props.setVisible(true);
      }

      return locateDuplicates(activeId, activeType, customerId).then((result) => {
        const duplicates = result.duplicates.filter(c => c.id !== customerId);
        if (duplicates.length) {
          this.props.setVisible(true);
        }
      });
    },
  })
)(LocateDuplicatesButton);
